import axios, { getData } from "lib/axios";

export const getExpense = async ({ reportId, expenseId }) => {
  return axios.get(`reports/${reportId}/expenses/${expenseId}`).then(getData);
};

export const postNewExpense = async (reportId, data) => {
  return axios.post(`reports/${reportId}/expenses`, data).then(getData);
};

export const deleteExpense = async (reportId, expenseId) => {
  return axios
    .delete(`reports/${reportId}/expenses/${expenseId}`)
    .then(getData);
};

export const putEditExpense = async (reportId, expenseId, data) => {
  return axios
    .put(`reports/${reportId}/expenses/${expenseId}`, data)
    .then(getData);
};
